<template>
    <div class="asset-tabpage">
        <!-- 车架数据页双页签：车架台账 + 全部车架保险绑定（懒加载，切到才请求） -->
        <el-tabs v-model="tab" class="asset-tabs">
            <el-tab-pane label="车架数据" name="chassis" lazy>
                <asset-crud kind="chassis" />
            </el-tab-pane>
            <el-tab-pane label="车架保险" name="bindings" lazy>
                <binding-assets />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import AssetCrud from './components/AssetCrud'
    import BindingAssets from './components/BindingAssets'
    export default {
        name: 'pageAssetChassisData',
        components: { AssetCrud, BindingAssets },
        data: () => ({ tab: 'chassis' })
    }
</script>

<style lang="scss" scoped>
.asset-tabpage {
    background: #fff;
    min-height: 400px;
    padding-top: 16px;

    .asset-tabs /deep/ .el-tabs__header {
        margin: 0 0 0 16px;
    }

    .asset-tabs /deep/ .el-tabs__content {
        overflow: visible;
    }
}
</style>
